module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3ef0ce285e2eeaf320c2a23e8bec0183.png";